import React from "react"
import JQuery from "jquery"

const StoreLine = ({ store, textKeys, availableOnWeb, alwaysShowStock }) => {
  const stockPrint = textKeys.storeStockInStockText?.replace("{quantity}", Math.max(0, store.Stock))
  const webStockPrint = textKeys.storeStockWebStockText
  const noneInStock = store.Stock <= 0
  const fewInStock = store.Stock <= 1
  const checkmarkModifier = noneInStock ? " empty-stock" : fewInStock ? " few-stock" : ""

  const stockTextElement =
    alwaysShowStock || store.IsEligibleForPickup || !availableOnWeb ? (
      <div className="stock-count">
        <p className={"validation-checkmark" + checkmarkModifier}></p>
        {stockPrint}
      </div>
    ) : (
      <div className="stock-count">{webStockPrint}</div>
    )

  const addToBasketElement = availableOnWeb ? (
    <a className="overlay-add-product" onClick={() => overlayAddProductClick(store.StoreId)} value={textKeys.addToBasketButtonText}>
      <span className="linktext">{textKeys.addToBasketButtonText}</span>
      <i className="icon-handbag icons"></i>
    </a>
  ) : undefined
  return (
    <div className="shop-info">
      <h4>
        <a href={store.ContentUrl}>{store.ShopTitle}</a>
      </h4>
      <div className="shop-contact-info">
        {store.Road}, {store.PostCode} {store.Municipality},
      </div>
      <div className="shop-phone">Telefon: {store.PhoneNumber}</div>
      <div className="right-aligned">
        {stockTextElement}
        {addToBasketElement}
      </div>
      <div className="clear"></div>
    </div>
  )
}

// this is ugly and bad, but the functionality needs to work
const overlayAddProductClick = (store) => {
  var addProductbutton = JQuery("#add-product")
  if (JQuery(addProductbutton).prop("disabled")) return false

  var val = JQuery(addProductbutton).closest(".product-info").find("#code").val()
  var careProducts = JQuery(".care-products").find("input[name='care-product-checkbox']")
  var careProductCodes = []
  careProducts.each(function (index, value) {
    if (JQuery(value).prop("checked")) {
      careProductCodes.push(JQuery(value).val())
    }
  })

  window.addItemTo("basket", val, careProductCodes, store)
  JQuery("#pageOverlay").html(null).show()
}

export default StoreLine
